import { Link } from 'react-router-dom'
import { PageContainer, PageHeader } from '../../components/Layout'
import { Card, CardContent, Button } from '../../components/UI'
import { useRentalTechData } from './useRentalTechData'

const KpiCard = ({ title, value }) => (
  <Card>
    <CardContent className="p-4">
      <p className="text-xs uppercase tracking-wide text-gray-500">{title}</p>
      <p className="text-2xl font-semibold text-gray-900 mt-1">{value}</p>
    </CardContent>
  </Card>
)

export default function RentalTechDashboard() {
  const { dashboard, loading } = useRentalTechData()

  const claims = dashboard?.metric_claims || {}

  return (
    <PageContainer>
      <div className="space-y-6">
        <PageHeader
          title="RentalTech LATAM"
          subtitle="SaaS multi-tenant para alquiler industrial: ERP + IoT + IA + Facturacion LATAM"
          actions={<Link to="/rentaltech/orders"><Button>Nueva reserva</Button></Link>}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-4">
          <KpiCard title="Utilizacion Financiera" value={`${dashboard?.utilization_financial_pct || 0}%`} />
          <KpiCard title="Utilizacion en Tiempo" value={`${dashboard?.utilization_time_pct || 0}%`} />
          <KpiCard title="Equipos Inactivos" value={dashboard?.inactive_equipment || 0} />
          <KpiCard title="ROI Preventivo" value={`${dashboard?.preventive_roi_pct || 0}%`} />
          <KpiCard title="CAPEX vs OPEX" value={`$${Number(dashboard?.capex_projected || 0).toLocaleString()} / $${Number(dashboard?.opex_projected || 0).toLocaleString()}`} />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Card>
            <CardContent className="p-5 space-y-2 text-sm text-gray-700">
              <h3 className="text-lg font-semibold text-gray-900">Impacto Comercial para Demo</h3>
              <p>+31% reduccion mantenimiento correctivo</p>
              <p>-48% reduccion tiempo administrativo</p>
              <p>+15% mejora utilizacion de flota</p>
              <p>ROI mensual estimado: ${Number(claims?.monthly_roi_estimate || 0).toLocaleString()}</p>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-5 space-y-3 text-sm text-gray-700">
              <h3 className="text-lg font-semibold text-gray-900">Recorrido Demo Comercial</h3>
              <ol className="list-decimal pl-4 space-y-1">
                <li>Reserva en Arrendamientos + validacion anti-overbooking.</li>
                <li>Cotizacion automatica y firma digital mock.</li>
                <li>Telemetria en vivo y alerta geofence.</li>
                <li>Mantenimiento preventivo autogenerado.</li>
                <li>Facturacion electronica DIAN/SAT/SUNAT.</li>
              </ol>
              <div className="pt-2 flex flex-wrap gap-2">
                <Link to="/rentaltech/orders"><Button variant="secondary">Arrendamientos</Button></Link>
                <Link to="/rentaltech/telemetry"><Button variant="secondary">Telemetria</Button></Link>
                <Link to="/rentaltech/billing"><Button variant="secondary">Facturacion</Button></Link>
              </div>
            </CardContent>
          </Card>
        </div>

        {loading ? <p className="text-sm text-gray-500">Actualizando indicadores...</p> : null}
      </div>
    </PageContainer>
  )
}
